var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"valid":_vm.valid})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }